import {Pipe, PipeTransform} from '@angular/core';
import {ArrayKeysPipe} from '../array-keys/array-keys.pipe';

@Pipe({
    name: 'errorArrayKeys',
    standalone: false
})
export class ErrorArrayKeysPipe extends ArrayKeysPipe implements PipeTransform {
  override transform(value: {[key: string]: any} = {}): string[] {
    const keys = super.transform(value);
    return keys.length > 1 ? keys.filter((key) => key !== 'required') : keys;
  }
}
